
import React from 'react';

import './link.scss';

const Link = (props) => {

	const {
		modifier,
		target,
		text,
		url,
		dataIntent,
		dataScope,
		dataId,
		dataText
	} = props;

	return (

		<a href={url}
			target={target}
			className={`link ${modifier ? `link--${modifier}` : ''}`}			
			data-intent={dataIntent}
			data-scope={dataScope}
			data-id={dataId}
			data-text={dataText}>
			{text}

		</a>

	)

}

export default Link;
